const style = (theme): any => ({
    actionCell: {
        cursor: 'default',
        textAlign: 'center',
        width: 140,
        '& button': {
            padding: theme.spacing(0.5),
            margin: theme.spacing(0.4),
            '& .MuiIcon-fontSizeSmall': {
                fontSize: '1rem',
            },
        },
    },
});
export default style;
